import { MainLinkButton } from "../styled/buttons/MainLinkButton";

const Cta: React.FC<any> = () => {
  return (
    <section cy-test-id="pricing-page-cta" className="flex flex-col items-center justify-center gap-[14px] pt-24 px-6 lg:px-0 text-center bg-gray-900">
      <span className="text-[24px] font-bold text-center">Don't want a subscription? No problem!</span>
      <p className="font-light text-center text-a-gray max-w-[821px]">While our subscription is the most affordable way to access our library, you can purchase collections anytime without a subscription directly from the product page.</p>
      <MainLinkButton href="/collections" size='large' className="mt-[26px] !w-3/4 lg:!w-[330px]">Explore Collections</MainLinkButton>
    </section>
  )
}

export default Cta;
